import React from "react";
import { RoomCollection } from "@lifeat/shared/data-models/Rooms/RoomEntity";
import { Routes } from "@lifeat/shared/system/RouteConstants";
import useDbValueListener from "@hooks/useDbValueListener";
import { buildRoute } from "@util/RouteUtil";
import DynamicLobbyInfoCardLayout from "./DynamicLobbyInfoCardLayout";

type DynamicLobbyInfoCardProps = {
    roomId: string;
    getSpaceThumbnail: (spaceId: string) => string;
};

export default function DynamicLobbyInfoCard({ roomId, getSpaceThumbnail }: DynamicLobbyInfoCardProps) {
    const room = useDbValueListener(RoomCollection.at(roomId).node);

    if (room == null) {
        return null;
    }
    return (
        <DynamicLobbyInfoCardLayout
            roomLink={`${buildRoute(Routes.Room)}/${roomId}`}
            thumbnailUrl={getSpaceThumbnail(room.spaceId)}
            roomName={room.roomName}
            roomDescription={room.roomDisplayInfo?.roomDescription ?? ""}
            guestCount={Object.keys(room.guests ?? {}).length}
            videoCallParticipantCount={room.videoCallParticipants?.length ?? 0}
        />
    );
}
